import { styled } from '@mui/material';

export const StyledAppointmentsBookingModalForm = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
});

export const StyledAppointmentsBookingModalBlock = styled('div')({
	position: 'relative',
	borderRadius: '10px',
	background: '#FFFFFF80',
	boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
	padding: '10px',
});

export const StyledAppointmentsBookingModalLabel = styled('span')({
	color: 'rgba(0, 0, 0, 0.38)',
	marginRight: '5px',
});
